// extracted by mini-css-extract-plugin
export default {"container":"UploadConstraints_container__dLSzY"};